import { useMemo } from 'react';
import { useRutilusQuery } from '@graphql/client/useRutilusQuery';
import { getTrashCollectionStateLeaderboard } from '@graphql/queries/rutilus/MillionPoundChallenge';
import { LeaderboardRow } from '../components/Leaderboard';

interface IOptions {
  skip?: boolean;
}

export const useTrashCollectionStateLeaderboard = ({ skip }: IOptions = {}) => {
  const { data, loading } = useRutilusQuery(getTrashCollectionStateLeaderboard, { skip });

  const statesRows = useMemo<LeaderboardRow[]>(() => {
    const entries = data?.trashCollectionStateLeaderboard ?? [];
    return [...entries]
      .filter((entry): entry is typeof entry & { stateName: string } => entry.stateName !== null)
      .sort((a, b) => b.totalWeightInKgs - a.totalWeightInKgs)
      .map((entry, index) => ({
        id: entry.stateCode,
        rank: index + 1,
        name: entry.stateName,
        weightInKg: entry.totalWeightInKgs,
      }));
  }, [data]);

  return { statesRows, isStatesLoading: loading };
};
